import { render, staticRenderFns } from "./occurrences-modal.vue?vue&type=template&id=6890a64e&"
import script from "./occurrences-modal.vue?vue&type=script&lang=js&"
export * from "./occurrences-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports